// Builds a url.
export const buildUrl = (baseUrl, path, params = {}) => {
  baseUrl = baseUrl.endsWith("/")
    ? baseUrl.substring(0, baseUrl.length - 1)
    : baseUrl;

  if (path) {
    path = !path.startsWith("/") && !path.startsWith("?") ? `/${path}` : path; // Prepend path with "/"
    baseUrl = `${baseUrl}${path}`;
  }

  const apiUrl = new URL(baseUrl);

  // Build the query string
  Object.keys(params).forEach((param) => {
    apiUrl.searchParams.append(param, params[param]);
  });

  return apiUrl;
};

// Converts a SearchParams object to a object literal.
export const searchParamsToObject = (searchParams) => {
  const entries = searchParams.entries();
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
};

// Converts an object literal to an instance of URLSearchParams.
export const objectToSearchParams = (searchParams) => {
  const newSearchParams = new URLSearchParams();
  const keys = Object.keys(searchParams);
  keys.forEach((key) => {
    newSearchParams.append(key, searchParams[key]);
  });

  return newSearchParams;
};
